import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Stack, Avatar, Container, Typography, Tooltip, IconButton } from '@mui/material';
import { Icon } from '@iconify/react';
import trash2Fill from '@iconify/icons-eva/trash-2-fill';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { set, sub, formatDistanceToNow } from 'date-fns';
import Page from '../components/Page';

const useStyles = makeStyles((theme) => ({
  text: {
    fontSize: '15px',
    color: '#33333',
    fontWeight: 500,
    lineHeight: '28px',
    letterSpacing: '1px',
    fontFamily: 'Reem Kufi, sans-serif',
    textAlign: 'left'
  }
}));

export default function Notification() {
  const classes = useStyles();
  const { id } = useParams();
  const navigate = useNavigate();
  const [notifDetail, setNotifDetail] = useState([]);
  const [notifDetailUser, setNotifDetailUser] = useState([]);
  const [t, i18n] = useTranslation();

  const getSingleNotif = async (notificationid) => {
    console.log('IIIID ==>', notificationid);
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    const response = await axios.get(`${API_ENDPOINT}/api/notifications/${notificationid}`, {
      headers: { Authorization: `Bearer ${token}` },
      data: {}
    });
    if (response.data.Message !== 'You are not allowed to get this notification') {
      setNotifDetailUser(response.data.created_by);
      setNotifDetail(response.data);
      console.log('notif Detail ==>', response.data);
    } else {
      console.log('NO DATA', response);
      navigate('/dashboard');
    }
  };

  useEffect(() => {
    console.log('IDk ==>', id);
    if (id && id !== '') {
      getSingleNotif(id);
    }
  }, [id]);

  if (notifDetail.length === 0) {
    return (
      <div>
        <h1>{t('load')} ...</h1>
      </div>
    );
  }

  return (
    <Page title={t('notification')}>
      <Container>
        <Stack
          direction="row"
          style={{ padding: '0px 10px' }}
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom style={{ paddingTop: 10 }}>
            {t('notification')}
          </Typography>
          <Tooltip title="delete">
            <IconButton style={{ color: '#f78181' }}>
              <Icon icon={trash2Fill} width={25} height={25} />
            </IconButton>
          </Tooltip>
        </Stack>

        <Card style={{ display: 'flex', padding: '10px' }}>
          <Container maxWidth="md" style={{ padding: '10px' }}>
            <Stack direction="row" mb={5}>
              <Typography>{t('From')} :</Typography>
              <Typography style={{ marginLeft: 20, color: '#f78181', flex: 1 }}>
                {notifDetailUser.username}
              </Typography>
              <Typography style={{ fontSize: 13, color: '#f78181' }}>
                {t('il y a')} {formatDistanceToNow(new Date(notifDetail.created_at))}
              </Typography>
            </Stack>
            <Stack direction="row" mb={5}>
              <Typography>{t('title')} :</Typography>
              <Typography style={{ marginLeft: 20, color: '#f78181' }}>
                {notifDetail.title}
              </Typography>
            </Stack>
            <Typography className={classes.text} gutterBottom>
              {notifDetail.text}
            </Typography>
          </Container>
        </Card>
      </Container>
    </Page>
  );
}
